import { useStores } from "src/hooks/use-stores.hook";
import styles from "./bonus-popup.module.css";

export const BonusPopup = ({
  onClose,
  onClick,
  className,
}: {
  onClose: () => void;
  onClick: () => void;
  className?: boolean;
}) => {
  const { localeStore } = useStores();

  return (
    <div className={`${styles.bonusPopup} ${styles.bonusPopupDefault} ${className}`}>
      <div className={styles.bonusPopupTitle}>{localeStore.t("trade.offer")}</div>
      <div className={styles.bonusPopupSubtitle}>{localeStore.t("trade.credit")}</div>
      <div
        className={styles.bonusPopupButton}
        onClick={() => {
          onClick();
          onClose();
        }}
      >
        {localeStore.t("trade.claim")}
      </div>
      <div className={styles.bonusPopupSkip} onClick={onClose}>
        {localeStore.t("trade.skip")}
      </div>
    </div>
  );
};
